var notification = require('notification'),
    loader = require('loader'),
    userServices = require('userProfileService'),
    cropperjs = require('cropper'),
    dataURLtoBlob = require('dataURLtoBlob');

var editTheme = (function() {

    var $avatar_input = $('#avatar-input'),
        $avatar_preview = $('#avatar-preview'),
        $avatar_save = $('#avatar-save'),
        $avatarBtn = $('#avatar-btn'),
        $background_input = $('#background-input'),
        $background_preview = $('#background-preview'),
        $backgroundBtn = $('#background-btn'),
        $background_save = $('#background-save'),
        selector = $('.page-content').attr('data-seletor');

    var cropNewImage = function() {
        $('.hidden-input').on("change", function() {
            var reader = new FileReader(),
                $input = $(this),
                $file = $input[0].files[0],
                fileType = $file["type"],
                $validImageTypes = ["image/gif", "image/jpeg", "image/png"];
            var id = $input.attr('id');
            if($.inArray(fileType, $validImageTypes) > 0) {
                switch(id) {
                    case 'background-input':
                        reader.readAsDataURL(($input)[0].files[0]);
                        reader.onload = function(e) {
                            $background_preview.attr('src', e.target.result);
                            cropBackground();
                        };
                        break;
                    case 'avatar-input':
                        reader.readAsDataURL(($input)[0].files[0]);
                        reader.onload = function(e) {
                            $avatar_preview.attr('src', e.target.result);
                            cropAvatar();
                        };
                        break;
                }
            } else {
                $('window').notification({
                    title: 'Please use a supported image type such as PNG or JPG',
                    error: true
                });
            }
        });
    };


    var cropBackground = function() {
        $background_preview.cropper({
            aspectRatio: 16 / 9
        });
        $backgroundBtn.fadeOut("fast", function() {
            $background_save.fadeIn("fast");
        });
    };


    var cropAvatar = function() {
        $avatar_preview.cropper({
            aspectRatio: 1,
            viewMode: 1
        });
        $('.hero-avatar').addClass('edit');
        $avatarBtn.fadeOut("fast", function() {
            $avatar_save.fadeIn("fast");
        });
    };


    var uploadNewImage = function() {
        $('.save-btn').on("click", function() {
            var id = $(this).attr('id');
            var preview_image;
            var database_image;
            switch(id) {
                case 'background-save':
                    preview_image = $background_preview.cropper('getCroppedCanvas').toDataURL("image/jpeg");
                    $background_preview.attr('src', preview_image);
                    $background_preview.cropper('destroy');
                    database_image = $('window').dataURLtoBlob(preview_image);
                    uploadImage(database_image, 'background');

                    $background_save.fadeOut(0, function() {
                        $backgroundBtn.fadeIn(0);
                    });
                    $background_input.val("");
                    break;
                case 'avatar-save':
                    preview_image = $avatar_preview.cropper('getCroppedCanvas').toDataURL("image/jpeg");
                    $avatar_preview.attr('src', preview_image);
                    $('.hero-avatar').removeClass('edit');
                    $avatar_preview.cropper('destroy');

                    database_image = $('window').dataURLtoBlob(preview_image);
                    uploadImage(database_image, 'profile');

                    $avatar_save.fadeOut(0, function() {
                        $avatarBtn.fadeIn(0);
                    });
                    $avatar_input.val("");
                    break;
            }
        });
    };


    var uploadImage = function(database_image, type) {
        var data = new FormData();
        data.append('file', database_image);
        data.append('type', type);
        switch(selector) {
            case 'club-theme':
                $('window').showLoader();
                var club_id = $('body').attr('data-club-id');
                data.append('club_id', club_id);
                updateClubThemeService(data, userProfileThemeResponse, userProfileThemeErrorResponse);
                break;
            case 'user-theme':
                $('window').showLoader();
                userProfileThemeService(data, userProfileThemeResponse, userProfileThemeErrorResponse);
                break;
            case 'create-club':

            break;
        }
    };


    var userProfileThemeResponse = function(response) {
        if(response.statusCode === 200) {
            $('window').notification({
                title: 'Your image has been successfully updated.'
            });
        } else {
            $('window').notification({
                title: 'There was an error updating your image.  Error: ' + response.message,
                error: true
            });
        }
    };


    var userProfileThemeErrorResponse = function() {
        $('window').notification({
            title: 'There was an error updating your image. Please try again or <a href="mailto:help@thecoachingmanual.com?subject=Cannot update my user theme">contact us if the problem persists</a>.',
            error: true
        });

    };


    var init = function() {
        cropNewImage();
        uploadNewImage();
    };


    return {
        init: init
    };


})();

if($('.edit-theme-function').length) {
    editTheme.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/profile/edit-profile-theme.js